export default {"src":"/_next/static/media/no_events.f459f0ae.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};